<template>
  <div class="row" v-if="coachingCounts">
    <div class="col-12 mb-4 mt-5">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{ name: 'unemployedPrivateCoachingList', params: { id: unemployed.id } }"
              :class="{ active: $route.name === 'unemployedPrivateCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Einzelcoaching ( {{ coachingCounts.privateCoachingCount }} )
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{ name: 'unemployedGroupCoachingList', params: { id: unemployed.id } }"
              :class="{ active: $route.name === 'unemployedGroupCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Gruppenmaßnahmen ( {{ coachingCounts.groupCoachingCount }} )
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{ name: 'unemployedSocioTherapyCoachingList', params: { id: unemployed.id } }"
              :class="{ active: $route.name === 'unemployedSocioTherapyCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Soziotherapie ( {{ coachingCounts.socioTherapyCoachingCount }} )
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{ name: 'unemployedAssistedLivingCoachingList', params: { id: unemployed.id } }"
              :class="{ active: $route.name === 'unemployedAssistedLivingCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Betreutes Wohnen ( {{ coachingCounts.assistedLivingCoachingCount }} )
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{ name: 'unemployedCaseManagementCoachingList', params: { id: unemployed.id } }"
              :class="{ active: $route.name === 'unemployedCaseManagementCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            DRV Fallmanagement ( {{ coachingCounts.caseManagementCoachingCount }} )
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{ name: 'unemployedPrivateLearningCoachingList', params: { id: unemployed.id } }"
              :class="{ active: $route.name === 'unemployedPrivateLearningCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Private Weiterbildung ( {{ coachingCounts.privateLearningCoachingCount }} )
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { piniaUserStore } from '@/store/piniaUserStore';
import { computed, defineProps } from 'vue';

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole  = piniaCurrentUser.value.roles[ 0 ];

const props = defineProps({
  unemployed: {
    type: Object,
    require: true,
  },
  coachingCounts: {
    type: Object,
    require: true,
  },
});
</script>

<style scoped>

</style>